import React, { useRef } from "react";
import styled from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

// --- Styled Components ---

const SectionContainer = styled.section`
  width: 100%;
  height: 100vh;
  /* background-color: #fdfbf9; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(to right, rgba(138, 120, 120, 0.15) 1px, transparent 1px),
      linear-gradient(to bottom, rgba(138, 120, 120, 0.15) 1px, transparent 1px);
    background-size: 150px 150px;
    mask-image: radial-gradient(circle, black 40%, transparent 90%);
    pointer-events: none;
  }
`;

const MarqueeRow = styled.div`
  display: flex;
  white-space: nowrap;
  font-family: "Montserrat", serif;
  font-size: 8vw;
  line-height: 0.8;
  text-transform: uppercase;
  color: #8a7878;
  font-weight: 800;
  width: max-content;
  will-change: transform;
  transform: translateX(100vw);
  position: relative;
  z-index: 2;
`;

const Word = styled.span`
  margin-right: 0.5em;
  &:nth-child(even) {
    font-style: italic;
  }
`;

// --- Component ---

const StaggeredTextSection = () => {
  const containerRef = useRef();
  const row1 = useRef();
  const row2 = useRef();
  const row3 = useRef();

  useGSAP(
    () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top",
          // CHANGED: Shortened distance to reduce dead scroll space
          end: "+=260%",
          scrub: 1,
          pin: true,
          anticipatePin: 1,
        },
      });

      // Row 1 starts first, moves slowest
      tl.to(
        row1.current,
        {
          x: "-150%",
          duration: 2, // Adjusted duration for snappier feel
          ease: "none",
        },
        0.1, // Moved start time earlier
      );

      // Row 2 starts a bit later, moves faster
      tl.to(
        row2.current,
        {
          x: "-110%",
          duration: 1.7,
          ease: "none",
        },
        0.4,
      );

      // Row 3 starts last, moves fastest
      tl.to(
        row3.current,
        {
          x: "-100%",
          duration: 1.5,
          ease: "none",
        },
        0.5,
      );
    },
    { scope: containerRef },
  );

  return (
    <SectionContainer ref={containerRef}>
      <MarqueeRow ref={row1}>
        <Word>Einfach</Word>
      </MarqueeRow>

      <MarqueeRow ref={row2}>
        <Word>wohlfühlen</Word>
      </MarqueeRow>

      <MarqueeRow ref={row3}>
        <Word>in deiner Haut</Word>
      </MarqueeRow>
    </SectionContainer>
  );
};

export default StaggeredTextSection;
